import * as Sentry from "@sentry/react";
import { initBrowserSentry, parseSampleRate } from "@quovy/browser-telemetry";

import { SENTRY_DSN, SENTRY_ENVIRONMENT, STACK_NAME } from "./lib/runtime-config";

initBrowserSentry({
  service: "control-plane-portal",
  dsn: SENTRY_DSN,
  environment: SENTRY_ENVIRONMENT,
  stackName: STACK_NAME,
  mode: import.meta.env.MODE,
  forceLocal: import.meta.env.VITE_SENTRY_FORCE_LOCAL === "1",
  release:
    document.querySelector<HTMLMetaElement>('meta[name="sentry-release"]')?.content ||
    import.meta.env.VITE_SENTRY_RELEASE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  tracePropagationTargets: ["localhost", "127.0.0.1", /^https:\/\/.*$/],
  tracesSampleRate: parseSampleRate(
    import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
    import.meta.env.DEV ? 1 : 0.1,
  ),
  replaysSessionSampleRate: parseSampleRate(
    import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
    import.meta.env.DEV ? 1 : 0.1,
  ),
  replaysOnErrorSampleRate: parseSampleRate(
    import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
    1,
  ),
});
